// extracted by mini-css-extract-plugin
export default {"projects":"projectsPage_projects__mmuPG","summary":"projectsPage_summary__zp6UC","summaryContainer":"projectsPage_summaryContainer__CyHs7"};